import { useQuery } from '@tanstack/react-query';
import { fetchDashboardStats, type DashboardStats } from '@/lib/api';
import { useDashboardIdentity } from './useDashboardIdentity';

/** How often the All-time revenue tile re-reads GET /dashboard/stats. */
export const DASHBOARD_STATS_REFETCH_MS = 60_000;

/**
 * GET /dashboard/stats for the All-time revenue tile: revenue.total is
 * every completed, user-stopped and system-stopped session's cost.total in
 * the caller's dashboard scope, the same statuses, field and scope as the
 * operator summary's Revenue today, with no date bound. Keyed by viewer
 * identity like the other dashboard reads.
 *
 * A 60 s poll (visible tab only), not live: the route sums every session
 * in scope (revenue and energy, all time), and a live session round can
 * come every 5 s per tab, so LIVE_QUERY_KEYS leaves this key out
 * (lib/liveUpdates.ts). An all-time total barely moves in a minute.
 */
export function useDashboardStats() {
  const identity = useDashboardIdentity();
  return useQuery<DashboardStats>({
    queryKey: ['dashboard', identity, 'stats'],
    queryFn: () => fetchDashboardStats(),
    staleTime: DASHBOARD_STATS_REFETCH_MS,
    refetchInterval: DASHBOARD_STATS_REFETCH_MS,
    refetchIntervalInBackground: false,
  });
}
